(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8c83"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8c83"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8QXEa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $672172b11377b86a$export$2e2bcd8739ae039; });

var $2Xzd1 = parcelRequire("2Xzd1");
var $672172b11377b86a$var$eventsLoadMore = {
    /**
     * Binds the load-more control of every events block inside root, or of root itself when it
     * is one. Safe to call repeatedly: ACF replaces the preview DOM after every field change.
     */ init: function init(root) {
        var _this = this;
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _blocks;
        var scope = root || document;
        var blocks = [];
        if (scope.matches && scope.matches('.events')) blocks.push(scope);
        if (scope.querySelectorAll) (_blocks = blocks).push.apply(_blocks, (0, $2Xzd1._)(scope.querySelectorAll('.events')));
        blocks.forEach(function(eventsBlock) {
            eventsBlock.querySelectorAll('.events__load-more').forEach(function(button) {
                _this.bindButton(button, eventsBlock, options);
            });
        });
    },
    bindButton: function bindButton(button, eventsBlock) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var listing = eventsBlock.querySelector('.events__listing');
        if (!listing || button.dataset.eventsReady === 'true') return;
        button.dataset.eventsReady = 'true';
        button.addEventListener('click', function() {
            _this.loadMore(button, eventsBlock, listing, options);
        });
    },
    loadMore: function loadMore(button, eventsBlock, listing) {
        // Localized by wp_localize_script on this script's own window, which is the page on the
        // frontend and the editor window in the block editor, never the canvas iframe.
        var settings = window.ajax;
        if (!settings) return;
        var nextPage = parseInt(button.dataset.paged, 10) + 1;
        button.disabled = true;
        eventsBlock.classList.add('events--loading');
        var body = new URLSearchParams({
            action: settings.action_name,
            nonce: settings.nonce,
            paged: nextPage,
            posts_per_page: button.dataset.postsPerPage
        });
        fetch(settings.ajax_url, {
            method: 'POST',
            body: body,
            credentials: 'same-origin'
        }).then(function(response) {
            return response.json();
        }).then(function(response) {
            if (!response.success) {
                button.disabled = false;
                return;
            }
            listing.insertAdjacentHTML('beforeend', response.data.html);
            button.dataset.paged = nextPage;
            button.disabled = false;
            if (!response.data.has_more) button.remove();
        }).catch(function() {
            button.disabled = false;
        }).finally(function() {
            eventsBlock.classList.remove('events--loading');
        });
    }
};
var $672172b11377b86a$export$2e2bcd8739ae039 = $672172b11377b86a$var$eventsLoadMore;
// The editor boots this module through src/js/_editor.js instead.
if (!window.acf) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() {
        return $672172b11377b86a$var$eventsLoadMore.init(document, {
            isEditor: false
        });
    });
    else $672172b11377b86a$var$eventsLoadMore.init(document, {
        isEditor: false
    });
}

});
parcelRegister("2Xzd1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $227c6742e0ff6f82$export$71511d61b312f219; });

var $gUOYc = parcelRequire("gUOYc");

var $Q6yVl = parcelRequire("Q6yVl");

var $4S8xA = parcelRequire("4S8xA");

var $ihB7G = parcelRequire("ihB7G");
function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $gUOYc._)(arr) || (0, $Q6yVl._)(arr) || (0, $ihB7G._)(arr) || (0, $4S8xA._)();
}

});
parcelRegister("gUOYc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c50969dc1df61e8b$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $gNF1f._)(arr);
}

});
parcelRegister("gNF1f", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c3b10a83b523f372$export$71511d61b312f219; });
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("Q6yVl", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09c9f293d010c0e1$export$71511d61b312f219; });
function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("4S8xA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $38c2d4931cb7a7c4$export$71511d61b312f219; });
function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("ihB7G", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d4f69c5c6c4654b1$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $gNF1f._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $gNF1f._)(o, minLen);
}

});




parcelRequire("8QXEa");
})();
//# sourceMappingURL=ajax.js.map
